module.exports = __webpack_public_path__ + "static/media/close-sans.02d999ec.svg";